(function () {
  'use strict';

  /* @ngdoc object
   * @name configDistribution
   * @description
   *
   */
  angular
    .module('configDistribution', [
      'ui.router'
    ]);
}());
